/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Account Manager API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AccountType = {
    Enterprise: 'enterprise',
    Personal: 'personal'
} as const;
export type AccountType = typeof AccountType[keyof typeof AccountType];


export function AccountTypeFromJSON(json: any): AccountType {
    return AccountTypeFromJSONTyped(json, false);
}

export function AccountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountType {
    return json as AccountType;
}

export function AccountTypeToJSON(value?: AccountType | null): any {
    return value as any;
}

